// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yimc","title":"styles_title__1bkV4"};